export default {
    "Sivut": "Páginas",
    "Ei luokiteltu": "Sin categoría",
    "Viimeiset 8 viikkoa": "Últimas 8 semanas",
    "Vie palautteet": "Exportar comentarios",
    "Ulkoasuasetukset": "Configuración de apariencia",
    "Logo": "Logotipo",
    "Väri": "Color",
    "Logon tulee olla PNG-tiedosto, jonka tausta on läpinäkyvä.": "El logotipo debe ser un archivo PNG con fondo transparente.",
    "Ei logoa": "Sin logotipo",
    "Valitse logo": "Elegir logotipo",
    "Logon tulee olla PNG-tiedosto.": "El logotipo debe ser un archivo PNG.",
    "Tiedosto on liian suuri (max 5 MB).": "El archivo es demasiado grande (máx. 5 MB).",
    "Logon tausta tulee olla läpinäkyvä.": "El fondo del logotipo debe ser transparente.",
    "Tiedostoa ei voitu lukea kuvana.": "No se pudo leer el archivo como imagen.",
    "Logon tallennus epäonnistui.": "No se pudo guardar el logotipo.",
    "Poista logo": "Eliminar logotipo",
    "Logon poistaminen epäonnistui.": "No se pudo eliminar el logotipo.",
    "Näytön logo korvaa yrityksen logon tällä näytöllä. Kuvan ei tarvitse olla neliö.": "El logotipo de la pantalla sustituye al logotipo de la empresa en esta pantalla. La imagen no necesita ser cuadrada.",
    "Tehosteväriä käytetään sovelluksen painikkeissa, otsikoissa ja korostuksissa.": "El color principal se utiliza en los botones, encabezados y acentos de la aplicación.",
    "Esikatselu": "Vista previa",
    "Esimerkki": "Ejemplo",
    "Painike": "Botón",
    "Värin tallennus epäonnistui.": "No se pudo guardar el color.",
    "Pääkäyttäjät": "Usuarios principales",
    "Vain pääkäyttäjät voivat lisätä tai poistaa toisia pääkäyttäjiä.": "Solo los usuarios principales pueden añadir o eliminar otros usuarios principales.",
    "Näytä loki": "Mostrar registro",
    "Lisää pääkäyttäjä": "Añadir usuario principal",
    "Ei pääkäyttäjiä": "Sin usuarios principales",
    "Et voi poistaa itseäsi pääkäyttäjistä": "No puedes eliminarte a ti mismo de los usuarios principales",
    "Viimeistä pääkäyttäjää ei voi poistaa": "El último usuario principal no se puede eliminar",
    "Poista pääkäyttäjistä": "Eliminar de usuarios principales",
    confirm_remove_mainuser: "¿Seguro que deseas eliminar al usuario {name} de los usuarios principales? El usuario permanecerá en el sistema como usuario normal.",
    "Hae käyttäjää": "Buscar usuario",
    "Kirjoita nimi tai sähköposti": "Escribe nombre o correo electrónico",
    "Ei tuloksia": "Sin resultados",
    "Lisää pääkäyttäjäksi": "Añadir como usuario principal",
    "Pääkäyttäjän lisääminen epäonnistui": "No se pudo añadir el usuario principal",
    "Pääkäyttäjien muutosloki": "Registro de cambios de usuarios principales",
    "Ei merkintöjä": "Sin entradas",
    "Toiminto": "Acción",
    "Suoritti": "Realizado por",
    "Pääkäyttäjän oikeudet lisätty": "Permisos de usuario principal concedidos",
    "Pääkäyttäjän oikeudet poistettu": "Permisos de usuario principal eliminados",

    "feedback_newview_info": "¡Estamos renovando la gestión de comentarios! Prueba la nueva vista a continuación. La nueva interfaz será el predeterminado en el futuro.",
    "Uusi näkymä": "Nueva vista",
    "Ohjeet": "Instrucciones",
    "Puhelinnumero": "Número de teléfono",
    "Pitkä vastaus": "Respuesta larga",
    "Lyhyt vastaus": "Respuesta corta",
    "Valitse yksi": "Selecciona uno",
    "Takaisin": "Volver",
    "Saapuneet / luokka": "Bandeja de entrada / categoría",
    "Vanha näkymä": "Vista antigua",
    "Päivitä": "Actualizar",
    "Näytä valmiit": "Mostrar completados",
    "Tieto ei näy palautteen lähettäjälle": "No visible para quien envió el comentario",
    "Sisäinen otsikko": "Título interno",
    "Ei valmiita palautteita": "No hay comentarios completados",
    "Ei saapuneita palautteita": "No hay comentarios entrantes",
    "Ei käsittelyssä olevia palautteita": "No hay comentarios en curso",
    "Näytä infotv näytöillä": "Mostrar en pantallas de Infotv",
    "Ei käytössä": "No está en uso",
    "Lomake": "Formulario",
    "Käytä mukautettua lomaketta": "Usar formulario personalizado",
    "Poista palautetyyppi käytöstä ja tallenna muutokset muokataksesi lomakekenttiä": "Desactiva el tipo de comentario y guarda los cambios para editar los campos del formulario",
    "Sisältö": "Contenido",
    "Asetukset": "Ajustes",
    "Lataa ja lisää": "Subir y añadir",
    "Näyttö": "Pantalla",
    "Toissijainen sisältö (30%)": "Contenido secundario (30%)",
    "Pääsisältö (70%)": "Contenido principal (70%)",
    "Alatunnisteen tekstit": "Textos de pie de página",
    "Lisää teksti": "Añadir texto",
    "Näytöt": "Pantallas",
    "Ulkoasu": "Apariencia",
    "Sää": "Tiempo",
    "Näytön sisällönhallinta": "Gestión de contenido de la pantalla",
    "Asettelu": "Diseño",
    "Haluatko varmasti poistaa sisällön näytöltä?": "¿Estás seguro de que quieres eliminar el contenido de la pantalla?",
    "Jaettu asettelu (70% / 30%)": "Diseño dividido (70% / 30%)",
    "Koko leveys": "Ancho completo",
    "Tumma tila": "Modo oscuro",
    "Näytä alatunniste": "Mostrar pie de página",
    "Sisällön näyttöaika (sekuntia)": "Tiempo de visualización del contenido (segundos)",
    "Valitse kirjastosta": "Seleccionar de la biblioteca",
    "Ei hakutuloksia": "No hay resultados de búsqueda",
    "Ei kuvia kirjastossa": "No hay imágenes en la biblioteca",
    "Lisää näytölle": "Añadir a la pantalla",
    "Virhe lisättäessä sisältöä": "Error al añadir contenido",
    "kohdetta": "elementos",
    "Lisää": "Añadir",
    "Lataa kuva": "Subir imagen",
    "Kirjastosta": "De la biblioteca",
    "Uutiset": "Noticias",
    "Tapahtumat": "Eventos",
    "Lisää sisältöä yllä olevilla painikkeilla": "Añade contenido usando los botones de arriba",
    "aktiivista uutista.": "noticias activas.",
    "Näytetään max 5 uusinta uutista": "Mostrando un máximo de 5 noticias más recientes",
    "Ei aktiivisia uutisia": "No hay noticias activas",
    "Ilmoittautuneet": "Registrados",
    "permanent_pages_info": "Las páginas permanentes aparecen en el menú de la aplicación Piiri como secciones propias (por ejemplo, con el título Nuestra empresa). Puedes crear nuevas secciones si quieres agrupar el contenido de las páginas permanentes en temas separados que se muestran en el menú. Una nueva sección aparecerá en el menú cuando se reinicie la aplicación o se actualice la página del navegador",
    "Osio": "Sección",
    "Luo uusi osio": "Crear nueva sección",
    "Pysyvät sivut": "Páginas permanentes",
    "Uusi kyselytyökalu": "Nueva herramienta para encuestas",
    "Lomakkeella on vastauksia. Muokkaus rajoitettu.": "El formulario tiene respuestas. Se impide la eliminación de campos y opciones de respuesta.",
    "Huom: Lomaketta voi muokata rajoitetusti sen jälkeen kun siihen on tullut vastauksia.": "Nota: El formulario solo puede editarse de forma limitada después de que se hayan enviado respuestas.",
    "surveyinfo1": "Estamos renovando las encuestas. Puedes probar la nueva herramienta de encuestas",
    "surveyinfo2": "La aplicación móvil de Piiri debe actualizarse a la nueva versión (1.15.0) para que las encuestas creadas con la nueva herramienta de encuestas sean visibles para los usuarios.",
    "Sinulla ei ole oikeuksia kaikkiin tämän julkaisun ryhmiin.": "No tienes permisos para todos los grupos de esta publicación.",
    "Voit tarkastella julkaisua, mutta et voi tehdä muutoksia.": "Puedes ver la publicación, pero no puedes hacer cambios.",
    "Oletus": "Predeterminado",
    "Vie kaaviot kuvana": "Exportar gráficos como imagen",
    "Suodattimet": "Filtros",
    "Tyhjennä": "Limpiar",
    "Aikavyöhyke": "Zona horaria",
    "Vastausvaihtoehto": "Opción de respuesta",
    "Lisää vaihtoehto": "Añadir opción",
    "Tyhjä vaihtoehto": "Opción vacía",
    "Vaihtoehto": "Opción",
    "Vastausvaihtoehdot": "Opciones de respuesta",
    "Haluatko varmasti poistaa vastausvaihtoehdon?": "¿Estás seguro de que quieres eliminar la opción de respuesta?",
    "vastausta": "respuestas",
    "Ei vastauksia": "Sin respuestas",
    "Kentällä ei ole otsikkoa": "El campo no tiene título",
    "Klikkaa muokataksesi kenttää": "Haz clic para editar el campo",
    "Ohjeteksti (valinnainen)": "Texto de ayuda (opcional)",
    "Päivämäärä": "Fecha",
    "Pakollinen": "Obligatorio",
    "Kentän otsikko": "Título del campo",
    "Tietotyyppi": "Tipo de dato",
    "Vastausaika on pakollinen": "El tiempo de respuesta es obligatorio",
    "Monirivinen teksti": "Texto multilínea",
    "Ei kysymyksiä. Lisää ensimmäinen kysymys vasemmalta.": "No hay preguntas. Añade la primera pregunta desde la izquierda.",
    "Monivalinta": "Opción múltiple",
    "Valinta": "Selección",
    "Valitse vähintään yksi ryhmä": "Selecciona al menos un grupo",
    "Teksti": "Texto",
    "Lisää kysymys": "Añadir pregunta",
    "Lomakkeen kentät": "Campos del formulario",
    "Julkaise ryhmiin": "Publicar en grupos",
    "Kopioi kysely": "Copiar encuesta",

    "Tietoa Piiri-sovelluksesta": "Acerca de la aplicación Piiri",
    "Vaadi lukukuittaus": "Requerir confirmación de lectura",
    "Selite (valinnainen)": "Descripción (opcional)",
    "Teksti näytetään käyttäjille lukukuittauksen yhteydessä": "El texto se muestra a los usuarios al confirmar la lectura",
    "Jos nostatte versionumeroa, käyttäjiltä vaaditaan sisällölle uudelleen lukukuittaus": "Si aumentas el número de versión, se pedirá a los usuarios que confirmen la lectura del contenido nuevamente",
    "Sivu": "Página",
    "Lukukuittaus saatu": "Confirmación de lectura recibida",
    "Ei lukukuittausta": "Sin confirmación de lectura",
    "Lukukuittauksia ei ole käytössä": "Las confirmaciones de lectura no están habilitadas",
    "Versio": "Versión",
    "Raportti": "Informe",
    "Ryhmän ylläpitäjä näkee vain ylläpitämiensä ryhmien tiedostot": "El administrador del grupo solo puede ver los archivos de los grupos que gestiona",
    "Muokkaa kansiota": "Editar carpeta",
    "Uusi kansio": "Nueva carpeta",
    "Uusi alikansio": "Nueva subcarpeta",
    "tiedostoa": "archivos",
    "Muokkaa": "Editarluo",
    "Lukukuittaukset": "Confirmaciones de lectura",
    "Failed to submit acknowledgment. Please try again.": "No se pudo enviar la confirmación. Inténtalo de nuevo.",
    "Kuittaa luetuksi": "Marcar como leído",
    "Lukukuittaus": "Confirmación de lectura",
    "Lukukuittaus vaaditaan": "Se requiere confirmación de lectura",
    "Olet kuitannut tämän luetuksi": "Has marcado esto como leído",
    "Sisältö on päivittynyt viime kuittauksesi jälkeen. Kuittaa uudelleen.": "El contenido se ha actualizado desde tu última confirmación. Confirma nuevamente.",
    "Tämä sisältö vaatii lukukuittauksen.": "Este contenido requiere confirmación de lectura.",
    "Your browser does not support the video tag.": "Tu navegador no admite la etiqueta de video.",
    "Avaa linkki": "Abrir enlace",
    "Kaikki tiedostot": "Todos los archivos",
    "Kansio": "Carpeta",
    "Avaa tiedosto": "Abrir archivo",
    "Kansion nimi": "Nombre de la carpeta",
    "Järjestys": "Orden de interfaz de usuario",
    "Haluatko varmasti poistaa kansion?": "¿Estás seguro de que quieres eliminar la carpeta?",
    "Anna kansion nimi": "Introduce el nombre de la carpeta",
    "Vie ilmoittautumiset": "Exportar inscripciones",
    "Avainsanoilla voidaan luokitella ja suodattaa uutisia.": "Las noticias se pueden clasificar y filtrar mediante palabras clave.",
    "Ryhmä on käytössä": "El grupo está activo",
    "Ryhmä ei ole käytössä": "El grupo no está activo",
    "DisableGroupInfo": "Un grupo puede marcarse como inactivo si no tiene:\n- administrador\n- canal de discusión\n- página de Nuestra empresa (u otra página permanente con nombre)\n\nAsí se marca un grupo activo como inactivo:\n- Elimina los derechos de administración del grupo en la gestión de usuarios.\n- Marca como inactivos los canales de discusión vinculados al grupo.\n- Elimina las páginas de Nuestra empresa creadas para el grupo o transfiérelas a otro grupo. Si la página permanente es visible para varios grupos, basta con quitar su visibilidad del grupo que se va a eliminar.\n\n¡Atención!\nOtro contenido creado para el grupo (noticias, eventos, encuestas, archivos) permanecerá en Piiri incluso cuando el grupo se elimine.",
    "Käyttäjä halitsee tietoa itse": "El usuario controla la información por sí mismo",
    "Käyttäjän kielivalinta": "Selección de idioma del usuario",
    "Tiedoston maksimikoko on 10MB": "El tamaño máximo del archivo es de 10 MB",
    "Peruuta": "Cancelar",
    "Avainsanat käytössä": "Palabras clave en uso",
    "Uusi ryhmä": "Nuevo grupo",
    "Ryhmän nimi": "Nombre del grupo",
    "Hae": "Buscar",
    "Järjestä": "Ordenar",
    "department-info": "El uso de los departamentos es voluntario. La agrupación del personal en departamentos solo se muestra en la sección 'Trabajamos juntos'. Si la empresa agrupa al personal en departamentos, los usuarios pueden buscar la información de contacto por departamento.",
    "Oletusuutiskuva": "Imagen predeterminada de noticias",
    "Julkaisuasetukset": "Configuración de publicación",
    "Oletusuutiskuvaa käytetään logon sijaan uutisissa mikäli uutisella ei ole omaa kuvaa.": "La imagen predeterminada se utiliza en lugar del logotipo en las noticias si la noticia no tiene su propia imagen.",
    "Hae otsikolla": "Buscar por título",
    "Kysymys julkaistaan heti": "La pregunta se publicará de inmediato",
    "Tapahtuma julkaistaan julkaisuaikana": "El evento se publicará en el momento de la publicación",
    "Nimi on pakollinen kaikilla kielillä": "El nombre es obligatorio en todos los idiomas",
    "Uusi osasto": "Nuevo departamento",
    "Kaikki": "Todos",
    "Osastot": "Departamentos",
    "Käännös suoritettu. Varmista käännöksen oikeellisuus ennen tallentamista.": "Traducción finalizada. Compruebe la exactitud de la traducción antes de guardarla.",
    "Suorita käännös": "Realizar la traducción",
    "Automaattinen käännös": "Traducción automática",
    "deepl_notice": "Se utilizará el servicio <a href='https://www.deepl.com/en/translator' target='_blank'> DeepL</a> para traducir el contenido. Tenga en cuenta que el texto traducido se enviará a los servidores de DeepLi para su procesamiento. La empresa es responsable de garantizar la exactitud e idoneidad del contenido traducido. La herramienta sólo está destinada a traducir contenidos para el Piiri.",
    "Haluatko varmasti poistaa käyttäjän? Toimintoa ei voi perua!": "¿Está seguro de que desea eliminar un usuario? La acción no se puede cancelar.",
    "Jos haluat päivittää kuvan, poista ensin olemassa oleva kuva": "Para actualizar una imagen, elimine primero la imagen existente",
    "ryhmää": "grupo",
    "Push-ilmoitukset käytössä": "Notificaciones push activadas",
    "Kansikuvat": "Imágenes de portada",
    "Ei kuvia, näytetään logo": "No hay fotos, se muestra el logotipo",
    "Lisää uusi kansikuva": "Añadir una nueva portada",
    "Enintään 5 kuvaa voidaan lisätä": "Se pueden añadir hasta 5 fotos",
    "Haluatko varmasti poistaa kuvan?": "¿Estás seguro de que quieres borrar la foto?",
    "Kuvien suositeltu kuvasuhde on 16:9, esim. 1920x1080px": "La relación de aspecto recomendada de las imágenes es 16:9, por ejemplo 1920x1080px",
    "Kuvat näytetään kuvakarusellissa": "Las fotos se muestran en el carrusel de fotos",
    "Vastauksiin liitetään nimi automaattisesti": "El nombre se añadirá automáticamente a las respuestas",
    "Kyselyyn voi vastata useita kertoja": "Puede responder al cuestionario varias veces",
    "Vastaukset kerätään anonyymisti": "Las respuestas se recogen de forma anónima",
    "Tätä asetusta ei voi muuttaa sen jälkeen kun kyselyyn on vastattu": "Esta configuración no puede modificarse una vez respondida la consulta.",
    "Salli useita vastauksia samalta käyttäjältä": "Permitir múltiples respuestas de un mismo usuario",
    "Palautteiden käsittelijäksi voidaan...": "Nota: Los comentarios pueden ser gestionados por el usuario root o por el administrador del grupo. Puede añadir los derechos del administrador de grupo en la información personal del usuario en Usuarios.",
    "Kaikki muutokset kirjataan lokiin": "Todos los cambios realizados en los gestores de respuesta se guardan en el registro (haga clic en el icono de la derecha para ver el registro).",
    "Valitse käsittelyoikeudet": "Elija sus derechos de tratamiento",
    "Käsittelyoikeudet": "Derechos de transformación",
    "Tallennus onnistui": "La grabación fue un éxito",
    "Aikaleima": "Cronología",
    "Suorittanut": "Completado por",
    "Kohdekäyttäjä": "Usuario objetivo",
    "Loki": "Loki",
    "CategoryInfo": "No se ha introducido ninguna clasificación de los comentarios. Cree sus propias categorías para los diferentes tipos de feedback seleccionando \"Nuevo tipo de feedback\" y escribiendo las instrucciones en el tipo de feedback.",
    "Palautetyypit": "Tipos de reacciones",
    "Palautetyypin nimi": "Nombre del tipo de respuesta",
    "Valitse palautteen tyyppi": "Seleccione el tipo de respuesta",
    "Otsikko on pakollinen kaikilla kielillä": "El título es obligatorio en todas las lenguas",
    "Ohje palautteen lähettäjälle (esim. mitä tietoja ilmoitukseen tulee lisätä)": "Instrucciones para la persona que envía la respuesta (por ejemplo, qué información incluir en la notificación)",
    "Lyhyt kuvaus (milloin palautetyyppiä käytetään)": "Breve descripción (cuando se utiliza el tipo de respuesta)",
    "Uusi palautetyyppi": "Nuevo tipo de respuesta",
    "Palautteiden luokittelu": "Clasificación de los comentarios",
    "Haluatko varmasti ottaa palautteen käsittelyyn?": "¿Está seguro de que quiere aceptar los comentarios?",
    "Käyttäjä on jättänyt yhteystiedot yhteydenottoa varten": "El usuario ha dejado datos de contacto para que te pongas en contacto con él",
    "Palaute on käsitelty": "Comentarios procesados",
    "Palauteilmoitukset": "Manejadores de retroalimentación",
    "Kirjoita viesti": "Escribir un mensaje",
    "Sinä": "Usted",
    "Voit lähettää yhden viestin vastauksena": "Puede enviar un mensaje en respuesta",
    "Haluatko varmasti lähettää viestin?": "¿Seguro que quieres enviar un mensaje?",
    "Palautteet": "Comentarios",
    "Näytä lähetetyt palautteet": "Mostrar comentarios enviados",
    "Piilota lähetetyt palautteet": "Ocultar comentarios enviados",
    "Haluatko jättää yhteystietosi henkilökohtaista vastausta varten?": "¿Quiere dejar sus datos de contacto para recibir una respuesta personal?",
    "Käsitelty": "Obtenido de",
    "Avoin": "Abrir",
    "Voit lähettää palautteen lähettäjälle viestin tai vastauksen sen jälkeen, kun palaute on otettu käsittelyyn": "Puede enviar un mensaje o una respuesta al remitente una vez procesada la respuesta.",
    "Tietoja": "Acerca de",
    "Palautteen lähettäjä voi vastata lähettämääsi viestiin tai viesteihin niin kauan, kunnes palaute on merkitty käsitellyksi.": "El remitente de la respuesta puede responder a los mensajes que envíe hasta que la respuesta se marque como procesada.",
    "Käyttäjä": "Usuario",
    "Yhteystiedot": "Póngase en contacto con",
    "Viestit": "Mensajes",
    "Käyttäjä ei ole jättänyt yhteystietoja": "El usuario no ha dejado ningún dato de contacto",
    "Lähetä lisäkysymys tai vastus": "Enviar una pregunta o respuesta complementaria",
    "Vie vastaukset": "Exportar respuestas",
    "Päivitykset": "Actualizaciones",
    "Kutsu uudet käyttäjät": "Invitar a nuevos usuarios",
    "Lisää uusi palautteiden käsittelijä": "Añadir un nuevo gestor de feedback",
    "Ilmoitus sähköpostiin": "Notificación por correo electrónico",
    "Push-viesti puhelimeen": "Mensaje push a tu teléfono",
    "Kutsu käyttäjiä": "Invitar a usuarios",
    "Käytä viestipohjaa": "Utilizar la base de mensajes",
    "Kutsuohje": "El siguiente mensaje se enviará por SMS a los usuarios seleccionados. Si lo desea, puede editar el mensaje antes de enviarlo.",
    "Varmista, että käyttäjien puhelinnumerot ovat oikein ennen viestin lähetystä.": "Asegúrate de que los números de teléfono de los usuarios son correctos antes de enviar el mensaje.",
    "Kutsumattomia käyttäjiä ei löytynyt": "No se han encontrado usuarios no invitados",
    "Kutsu valitut käyttäjät": "Invitar a los usuarios seleccionados",
    "Lähetys käynnissä, odota...": "Transmisión en curso, espera...",
    "Lähetys on valmis": "El envío está listo",
    "Kutsu käyttäjälle": "Invitación al usuario",
    "numeroon": "a",
    "epäonnistui": "fallido",
    "Päivitä lista": "Actualice su lista",
    "Viesti on pakollinen": "El mensaje es obligatorio",
    "Kirjoita vastaus": "Escribir una respuesta",
    "Vastauksia": "Respuestas",
    "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomutooja ovat ": "El formato de archivo no es compatible. Los formatos de archivo admitidos son",
    "Liitetiedosto": "Adjunto",
    "Halutessasi voi liittää liitetiedoston": "Si lo desea, puede adjuntar un anexo",
    "Halutessasi voit liittää mukaan kuvan tai pdf-tiedoston": "Si lo desea, puede adjuntar una imagen o un archivo pdf",
    "Liite": "Anexo",
    "Ladataan...": "Cargando...",
    "Vastausaika on päättynyt": "El plazo de respuesta ha expirado",
    "Ei ilmoittautumisia": "No hay inscripciones",
    "Voit lähettää viestin Ctrl Enter painikkeilla": "Puede enviar un mensaje pulsando Ctrl + Intro",
    "Omat keskustelut": "Mis conversaciones",
    "Näytä keskustelukanavat": "Mostrar canales de chat",
    "Yksityinen kanava": "Canal privado",
    "Hallinnoit tätä kanavaa": "Usted gestiona este canal",
    "Aloita uusi keskustelu": "Iniciar una nueva conversación",
    "Miten palautteet käsitellään": "Cómo se gestiona la retroalimentación",
    "Haku": "Obtenido de",
    "Omat tiedot ja asetukset": "Mis datos y configuraciones",
    "Julkaisuaika on pakollinen": "La fecha de publicación es obligatoria",
    "Kuvaus...": "Descripción...",
    "Saapunut ...": "Recibido ...",
    "Nimi puuttuu": "Falta el nombre",
    "Haluatko varmasti poistaa tapahtuman?": "¿Estás seguro de que quieres borrar el evento?",
    "Ylläpito": "Mantenimiento",
    "Etusivu": "Página de inicio",
    "Hallinta": "Gobernanza",
    "Muut": "Más",
    "Omat tiedot": "Datos personales",
    "Kirjaudu ulos": "Cerrar sesión",
    "Lähetä": "Enviar a",
    "Olet vastannut kyselyyn": "Ha respondido a la encuesta",
    "Kyselyt": "Consultas",
    "Vastausaika päättyy": "Fin del plazo de respuesta",
    "Ei kyselyjä": "Ninguna consulta",
    "Uusi tiedosto lisätty": "Nuevo archivo añadido",
    "Yritys": "Empresa",
    "Raahaa kuva tähän tai klikkaa tästä ja valitse kuva tiedostoista.": "Arrastre la imagen aquí o haga clic aquí y seleccione una imagen de los archivos.",
    "Kuponki": "Cupón de",
    "Otsikko": "Título",
    "Kuvaus": "Descripción",
    "Etu julkaistaan heti": "La prestación se publicará inmediatamente",
    "Etu tallennetaan luonnoksena": "La prestación se almacena en forma de borrador",
    "Julkaise": "Publicar en",
    "Tarkista lomakkeen tiedot": "Compruebe la información del formulario",
    "Poista": "Eliminar",
    "Tallenna": "Guardar",
    "Tallenna lisätieto": "Guardar más información",
    "Henkilöstöedut": "Prestaciones del personal",
    "Uusi etu": "Nueva ventaja",
    "Julkaistu": "Publicado el",
    "Keskustelukanavat": "Foros",
    "Nimi": "Nombre",
    "Kuva": "Imagen de",
    "Kanavan tyyppi": "Tipo de canal",
    "Yksityinen keskustelu": "Conversación privada",
    "Ryhmäkeskustelu": "Debate en grupo abierto",
    "Kanavaa hallinnoivat": "El canal está gestionado por",
    "Käytössä": "Obtenido de",
    "Kanava on käytössä": "El canal está en uso",
    "Kanava ei ole käytössä": "Canal no utilizado",
    "Uusi kanava": "Nuevo canal",
    "Aktiivinen": "Activo",
    "Klo": "En",
    "Ilmoittautuminen päättyy": "Cierre de inscripciones",
    "Ilmoittautumiset": "Inscripción",
    "#": "#",
    "Henkilö": "Persona",
    "Ilmoitautumisaika": "Fecha límite de inscripción",
    "Kommentti": "Comentario",
    "Tapahtumat": "Eventos",
    "Julkaise ryhmään": "Publicar en un grupo",
    "Tapahtuman alkuaika": "Hora de inicio del evento",
    "Tapahtuman päättymisaika": "Hora de finalización del acto",
    "Palauteasetukset": "Ajustes de retroalimentación",
    "Ilmoittautuminen": "Inscripción",
    "Kommentti ilmoittautumisen yhteydessä": "Comentarios al registrarse",
    "Tapahtuma julkaistaan heti": "El acontecimiento se publicará inmediatamente",
    "Tapahtuma tallennetaan luonnoksena": "El evento se guarda como borrador",
    "Ryhmä on pakollinen": "El grupo es obligatorio",
    "Otsikko ja teksti on pakollinen": "El título y el texto son obligatorios",
    "Alkuaika on pakollinen": "La hora de inicio es obligatoria",
    "Tarkista päättymisaika": "Compruebe la fecha de caducidad",
    "Tarkista ilmoittautumisen päättymisaika": "Compruebe el plazo de inscripción",
    "Otsikko tai teksti puuttuu": "Falta título o texto",
    "Uusi tapahtuma": "Nuevo evento",
    "Aika": "Tiempo",
    "Ryhmä": "Grupo",
    "Kysymykset & vastaukset": "Preguntas y respuestas",
    "Kysymys": "Pregunta",
    "Uusi kysymys": "Nueva pregunta",
    "Saapunut": "Obtenido de",
    "päivää sitten": "días atrás",
    "Käsittelyssä": "Obtenido de",
    "Otettu käsittelyyn": "Tomado en consideración",
    "Valmis": "Listo",
    "Palaute": "Comentarios",
    "Käyttäjä toivoo vastausta": "El usuario desea recibir una respuesta",
    "Käyttäjä ei toivo vastausta": "El usuario no desea recibir respuesta",
    "Käsittely": "Tratamiento",
    "Ota käsittelyyn": "Leer",
    "Sisäinen lisätieto": "Información adicional interna",
    "Sisäinen lisätieto ei näy palautteen lähettäjälle": "Información interna adicional no visible para el remitente de la respuesta",
    "Kuittaa käsitellyksi": "Acuse de recibo",
    "Palautekanava": "Canal de retroalimentación",
    "SUODATA": "ENVIAR",
    "Saapuneet": "Obtenido de",
    "Käsittely kesken": "Tratamiento en curso",
    "Valmiit": "Terminado",
    "Saapunut tänään": "Llegó hoy",
    "Lisää kuva klikkaamalla tai raahaamalla kuva tähän": "Haga clic o arrastre una imagen aquí para añadir una imagen",
    "Julkaisuaika": "Fecha de publicación",
    "Liitteet": "Anexos",
    "Lisää uusi liitetiedosto": "Añadir un nuevo archivo adjunto",
    "Voit lisätä sivulle liitteitä tallennuksen jälkeen": "Puedes añadir archivos adjuntos a la página después de guardarla",
    "Video": "Vídeo",
    "Lisää uutiseen video": "Añadir al vídeo de noticias",
    "Kysely": "Encuesta",
    "Lisää julkaisuun kysymys": "Añadir a la pregunta de publicación",
    "Kyselyyn on vastattu eikä kysymyksiä voi enää muokata": "El cuestionario ha sido contestado y ya no se puede editar",
    "Kysymykset": "Preguntas",
    "Uusi monivalintakysymys": "Nueva pregunta tipo test",
    "Uusi avoin kysymys": "Nueva pregunta abierta",
    "Kirjoita kysymys": "Escriba una pregunta",
    "Lisää vastausvaihtoehto": "Añadir una opción de respuesta",
    "Kirjoita vastausvaihtoehto": "Escriba una opción de respuesta",
    "Uutinen julkaistaan julkaisaikana": "Las noticias se publicarán en el momento de la publicación",
    "Uutinen tallennetaan luonnoksena": "Noticias guardadas como borrador",
    "Uutiset": "Noticias",
    "Uusi uutinen": "Novedades",
    "Näytä vastaukset": "Mostrar respuestas",
    "Julkaisupäivä": "Fecha de publicación",
    "Meidän yritys": "Nuestra empresa",
    "Valitse kuva": "Seleccione una imagen",
    "Lisää sivulle video": "Añadir un vídeo a la página",
    "Vimeo videon id": "Id de vídeo Vimeo",
    "Sivu julkaistaan heti": "La página se publicará inmediatamente",
    "Sivu tallennetaan luonnoksena": "La página se guarda como borrador",
    "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomuotoja ovat jpeg sekä png.": "El formato de archivo no es compatible. Los formatos de archivo compatibles son jpeg y png.",
    "Uusi sivu": "Página nueva",
    "Lisää alasivu": "Añadir una subpágina",
    "Yhteenveto": "Resumen",
    "Vastaukset": "Respuestas",
    "Vastausaika": "Tiempo de respuesta",
    "Otsikko ja kuvaus on pakollinen": "El título y la descripción son obligatorios",
    "Päivämäärä on pakollinen": "La fecha es obligatoria",
    "Kyselyssä ei ole yhtään kysymystä": "No hay preguntas en la encuesta",
    "Tarkista kysymykset": "Compruebe las preguntas",
    "Otsikko tai kuvaus puuttuu": "Sin título ni descripción",
    "Haluatko varmasti poistaaa kyselyn ja kaikki sen vastaukset?": "¿Estás seguro de que quieres borrar el cuestionario y todas sus respuestas?",
    "Uusi kysely": "Nueva encuesta",
    "Tiedosto": "Archivo en",
    "Linkki": "Enlace",
    "Valitse uusi tiedosto": "Seleccionar un nuevo archivo",
    "Tämä tieto on pakollinen": "Esta información es obligatoria",
    "Max 500 merkkiä": "Máximo 500 caracteres",
    "Tiedosto julkaistaan heti": "El archivo se publicará inmediatamente",
    "Tiedosto tallennetaan luonnoksena": "El archivo se guarda como borrador",
    "Tiedosto puuttuu": "Fichero perdido",
    "Linkki puuttuu": "Enlace perdido",
    "Tiedostot": "Archivos de",
    "Uusi tiedosto": "Nuevo archivo",
    "Avaa": "Abierto en",
    "Tyyppi": "Tipo",
    "Asetukset": "Ajustes",
    "Palautteiden käsittelykäytäntö": "Política de tratamiento de las reacciones",
    "Käyttäjät": "Usuarios",
    "Etunimi": "Nombre",
    "Sukunimi": "Apellido",
    "Puhelin": "Teléfono",
    "Sähköposti": "Correo electrónico",
    "Työtehtävä": "Descripción del puesto",
    "Näytä sähköposti kaikille": "Mostrar correo electrónico a todos",
    "Näytä puhelinnumero kaikille": "Enseña tu número de teléfono a todo el mundo",
    "Ryhmät": "Grupos",
    "Käyttäjä on yrityksen pääkäyttäjä, jolla on oikeudet julkaista kaikkiin ryhmiin": "El usuario es el usuario principal de la empresa, con derechos para publicar en todos los grupos.",
    "Ryhmän ylläpitäjä": "Administrador de grupo",
    "Suodata": "Filtrar por",
    "Uusi käyttäjä": "Nuevo usuario",
    "Näytä ryhmän ylläpitäjät": "Mostrar administradores de grupo",
    "Kaikki käyttäjät": "Todos los usuarios",
    "Yrityksen pääkäyttäjät": "Usuarios finales de la empresa",
    "Näytä kuponki": "Mostrar cupón",
    "Sulje": "Cerrar",
    "Kirjoita viestisi": "Escriba su mensaje",
    "Aloita keskustelu": "Iniciar una conversación",
    "Yksityiset keskustelut": "Conversaciones privadas",
    "Ei kanavia": "Sin canales",
    "Ryhmäkeskustelut": "Debates en grupo",
    "Keskustelut": "Debates",
    "Viesti poistettu": "Mensaje eliminado",
    "Poista viesti": "Borrar mensaje",
    "Olet ilmoittautunut tapahtumaan": "Se ha inscrito en un acto",
    "Peru ilmoittautuminen": "Registro en Perú",
    "Et ole ilmoittautunut tapahtumaan": "No se ha inscrito en el acto",
    "Ilmoittaudu mukaan": "Inscríbase para participar",
    "Jätä palaute tai kysymys": "Dejar un comentario o una pregunta",
    "Kiitos, viesti lähetetty": "Gracias, mensaje enviado",
    "Kirjoita palaute tai kysymys": "Escriba su opinión o haga una pregunta",
    "Haluan henkilökohtaisen vastauksen": "Quiero una respuesta personal",
    "Anna sähköposti tai puhelinnumero": "Introduzca su correo electrónico o número de teléfono",
    "Miten palautteet käsitellään?": "¿Cómo se gestionan los comentarios?",
    "Anna sähköpostiosoite tai puhelinnumero": "Introduzca su dirección de correo electrónico o número de teléfono",
    "Tervetuloa Piiriin": "Bienvenido al Piiri",
    "Käyttäjätunnus tai puhelinnumero": "Nombre de usuario o número de teléfono",
    "Jatka": "continuar",
    "Salasana": "Contraseña",
    "Kirjaudu sisään": "Conectarse",
    "Pin koodi": "Código pin",
    "Pin koodin saapumisessa voi kestää hetken.": "El código pin puede tardar un poco en llegar.",
    "Kirjautuminen epäonnistui": "Error al iniciar sesión",
    "Kirjautuminen epäonnistui, tarkista pin koodi": "Login fallido, compruebe su código pin",
    "Kirjaudutaan ulos...": "Firmando la salida...",
    "Uusimmat": "Lo último de",
    "Meillä töissä": "Trabaja con nosotros",
    "Piiri-artikkelit": "Artículos sobre Piiri",
    "Omat tiedot & asetukset": "Mis datos y configuraciones",
    "Tietoa Piiri-sovelluksesta": "Acerca de la aplicación Piiri",
    "Mikä on Piiri Kit?": "¿Qué es un Piiri Kit?",
    "Tietosuojaseloste": "Política de privacidad",
    "Töissä": "En el trabajo",
    "Poissa töistä": "Ausencia del trabajo",
    "Anna avainsana kaikilla kielillä.": "Introduzca la palabra clave en todos los idiomas.",
    "Avainsana": "Palabra clave",
    "Haluatko varmasti poistaa avainsanan?": "¿Está seguro de que desea eliminar la palabra clave?",
    "Muokkaa avainsanaa": "Editar palabra clave",
    "Luo uusi avainsana": "Crear nueva palabra clave",
    "Avainsanat": "Palabras clave",
    "Hae avainsanoja tai lisää uusi": "Buscar palabras clave o añadir una nueva",
    "Paina Enter luodaksesi uuden avainsanan": "Presione Enter para crear una nueva palabra clave",
    "Avainsanojen hallinta": "Gestión de palabras clave",
    "Uudistamme kyselyjä. Pääset kokeilemaan uutta kyselytyökalua": "Estamos renovando las encuestas. Puedes probar la nueva herramienta de encuestas",
    "tästä": "aquí",
    "Kyselyn vastaukset": "Respuestas de la encuesta",
    "Viimeisin vastaus": "Última respuesta",
    "Näytetään": "Mostrando",
    "Kyselyä ei löytynyt": "Encuesta no encontrada",
    "Saat PIN-koodin tekstiviestillä mikäli puhelinnumerosi on järjestelmässämme. Syötä se alle.": "Recibirás un código PIN por mensaje de texto si tu número de teléfono está en nuestro sistema. Introdúcelo a continuación.",
    "Jos et saanut PIN-koodia, tarkista että syötit puhelinnumerosi oikein.": "Si no recibiste el código PIN, verifica que hayas introducido correctamente tu número de teléfono.",
    "Kirjoita hakusana": "Escribe un término de búsqueda",
    "Hakusanan tulee olla vähintään 3 merkkiä pitkä": "El término de búsqueda debe tener al menos 3 caracteres"
}
